import {NOW} from './reference'

/**
 * Weight Freeze (v2) — the module clock.
 *
 * Seeded mounts (the dev harness, every unit test, the frozen Nobero dataset) run against the
 * dataset's pinned instant so a request raised "today" lands on the same day the fixtures were
 * authored against. A LIVE mount (the real route, talking to the backend) unpins it and reads the
 * wall clock — a submission recorded on 15 Sep must not be dated 7 Aug. Same shape, same reason,
 * as disputes-v2/data/clock.js; kept separate because the two modules deliberately never import
 * each other.
 *
 * Pinned by default: nothing changes for any existing consumer until index.js unpins on a live mount.
 */
let pinned = NOW

export function pinClock(date = NOW) {
  pinned = date
}

export function unpinClock() {
  pinned = null
}

export function isClockPinned() {
  return pinned !== null
}

export function nowDate() {
  return pinned ? new Date(pinned.getTime()) : new Date()
}

export function nowMs() {
  return nowDate().getTime()
}

export function todayISO() {
  return nowDate().toISOString().slice(0, 10)
}
